import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React, {ReactNode} from 'react';

import {GRAY_LIGHT} from 'ui-library/Colors';

// TODO BNCH-121165: Replace usage of SampleTypesListingTable with UI library component
export function Table({children}: {children: ReactNode}): JSX.Element {
  return <div className={css(styles.table)}>{children}</div>;
}

export function Header({children}: {children: ReactNode}): JSX.Element {
  return <div className="simpleDivTable-header">{children}</div>;
}

export function HeaderCell({children}: {children: ReactNode}): JSX.Element {
  return <div className={classNames('simpleDivTable-headerCell', css(styles.headerCell))}>{children}</div>;
}

export function Row({
  children,
  isBeingEdited,
  className,
  ...divProps
}: {children: ReactNode; isBeingEdited?: boolean} & React.HTMLAttributes<HTMLDivElement>): JSX.Element {
  return (
    <div
      {...divProps}
      className={classNames('simpleDivTable-row', isBeingEdited ? 'is-beingEdited' : undefined, className)}
    >
      {children}
    </div>
  );
}

export function Cell({children}: {children: ReactNode}): JSX.Element {
  return <div className={classNames('simpleDivTable-cell', css(styles.cell))}>{children}</div>;
}

export function EmptyCell({children}: {children: ReactNode}): JSX.Element {
  return <div className={css(styles.emptyCell)}>{children}</div>;
}

const styles = StyleSheet.create({
  table: {
    width: '100%',
    border: 1,
    borderStyle: 'solid',
    borderColor: GRAY_LIGHT,
    borderRadius: 4,
  },
  headerCell: {
    paddingRight: '14px',
    ':last-child': {
      paddingRight: 0,
    },
  },
  cell: {
    wordWrap: 'break-word',
    ':last-child': {
      paddingRight: 0,
    },
    paddingRight: '14px',
    lineHeight: '28px',
  },
  emptyCell: {
    width: '100%',
    lineHeight: '28px',
  },
});
